// ═══ 공용 밑줄 탭 (시안 1 확정, Jin 2026-08-26) ═══
// 말소대행 계정의 **모든 하위 탭**이 이 문법 하나를 쓴다 — 앱바 활성 밑줄과 같은 어휘.
// 정본은 CancelAgency.js 의 headerSeg 였고, 정산(현황|장부|입금|정산서)·세금계산서(발행|홈택스…)가
// 각자 pill 을 갖고 있어 세 화면이 달라 보였다. 여기로 승격해 한 곳만 고치면 전부 따라오게 한다.
//
// 사용처는 전부 `#dash-header-slot-left` 포털 안 — 타이틀 줄에 얹히는 것을 전제로 한 치수다.
//   · hover(비활성만)          → App.css `.ca-utab:not(.on):hover`
//   · 헤더 하단 보더 밀착 -10px → App.css `.ca-clean .ca-useg`
//   · 타이틀과의 간격 36px      → App.css `.ca-clean #dash-header-slot-left`
//   ⚠ 위 3 규칙은 `.ca-clean`(대행업체 셸) 하위라 다른 계정 화면엔 적용되지 않는다.
//
// items: [{label, on, onClick}]  — 탭 버튼. on 이면 파랑 밑줄 + 굵게.
//        [{label, href}]         — 외부 링크(새 탭). 앞에 세로 구분선이 붙고 한 톤 죽인 색.
import React from 'react';

function CaHeaderTabs({ items, isMobile }) {
  return (<span className="ca-useg" style={{display:'inline-flex',alignItems:'baseline',gap:isMobile?18:26}}>
    {(items||[]).map(function(it){
      var on=it.on;
      var st={padding:isMobile?'8px 2px 10px':'6px 2px 11px',whiteSpace:'nowrap',fontFamily:'inherit',cursor:'pointer',
        background:'none',border:'none',borderBottom:'3px solid '+(on?'#2563EB':'transparent'),
        fontSize:isMobile?13:13.5,fontWeight:on?800:600,color:on?'#1B3A5C':'#64748b',textDecoration:'none',
        display:'inline-flex',alignItems:'baseline',gap:4};
      if(it.href){
        return (<React.Fragment key={it.label}>
          <span style={{width:1,height:13,background:'#dbe3ec',alignSelf:'center'}}/>
          <a className={"ca-utab"} href={it.href} target="_blank" rel="noopener noreferrer"
            style={Object.assign({},st,{fontSize:12.5,color:'#94a3b8'})}>{it.label}</a>
        </React.Fragment>);
      }
      return (<button key={it.label} className={"ca-utab"+(on?" on":"")} onClick={it.onClick} style={st}>{it.label}</button>);
    })}
  </span>);
}

export default CaHeaderTabs;
